
export class DebugAPI {
    /** @param {import('../httpClient').HttpClient} http */
    constructor(http) {
        this.http = http;
    }

    /**
     * Test an agent configuration with a message
     * @param {Object} params
     * @param {Object} params.agentConfig - The agent configuration object
     * @param {string} params.message - The test message
     * @returns {Promise<{response: string, usage: Object}>}
     */
    testAgent({ agentConfig, message }) {
        return this.http.post("/debug/test-agent", {
            agentConfig,
            message
        });
    }
}
